<div id="app">
  <h1>Weather Checker</h1>
  <form (submit)="fetchWeather()">
    <input [(ngModel)]="city" name="city" placeholder="Enter a city name" />
    <button type="submit">Get Weather</button>
  </form>

  <div *ngIf="weatherData">
    <h2>Weather in {{ formattedCity }}:</h2>
    <p>{{ weatherData.weather[0]?.description }}</p>
    <p>Temperature: {{ weatherData.main?.temp }}°C / {{ convertToFahrenheit(weatherData.main?.temp) }}°F</p>
    <p>Humidity: {{ weatherData.main?.humidity }}%</p>
    <p>Wind Speed: {{ weatherData.wind?.speed }} km/h</p>
  </div>
</div>
